import { render } from "./WrongNetworkModal.vue?vue&type=template&id=f22f5b14"
import script from "./WrongNetworkModal.vue?vue&type=script&lang=js"
export * from "./WrongNetworkModal.vue?vue&type=script&lang=js"

import "./WrongNetworkModal.vue?vue&type=style&index=0&id=f22f5b14&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__